import { useEffect, useState } from "react";
import { trackEvent, trackGoogleConversion, GOOGLE_CONVERSION_LABEL_CLICK } from "./utils/analytics";

export const CALENDLY_URL = "https://calendly.com/jgarcia-29/30min";

export function removeCalendlyBadges() {
  document
    .querySelectorAll(".calendly-badge-widget, .calendly-badge-content")
    .forEach((node) => node.remove());
}

export function ensureCalendlyAssets() {
  if (!document.getElementById("calendly-widget-css")) {
    const link = document.createElement("link");
    link.id = "calendly-widget-css";
    link.href = "https://assets.calendly.com/assets/external/widget.css";
    link.rel = "stylesheet";
    document.head.appendChild(link);
  }

  if (!document.getElementById("calendly-widget-js")) {
    const script = document.createElement("script");
    script.id = "calendly-widget-js";
    script.src = "https://assets.calendly.com/assets/external/widget.js";
    script.async = true;
    document.body.appendChild(script);
  }
}

export function openCalendly() {
  removeCalendlyBadges();
  ensureCalendlyAssets();

  // Track the consultation booking click
  trackEvent("calendly_click_consultation", {
    event_category: "Engagement",
    event_label: "Clicked Book a Consultation",
  });
  trackGoogleConversion(GOOGLE_CONVERSION_LABEL_CLICK);

  if (window.Calendly) {
    window.Calendly.initPopupWidget({ url: CALENDLY_URL });
  } else {
    window.open(CALENDLY_URL, "_blank", "noopener,noreferrer");
  }
}

export default function CalendlyWidget() {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    removeCalendlyBadges();
    ensureCalendlyAssets();

    const interval = window.setInterval(() => {
      removeCalendlyBadges();
      if (window.Calendly) {
        setReady(true);
        window.clearInterval(interval);
      }
    }, 250);

    const timeout = window.setTimeout(() => window.clearInterval(interval), 8000);

    return () => {
      window.clearInterval(interval);
      window.clearTimeout(timeout);
    };
  }, []);

  return (
    <button
      id="lpf-floating-consultation-button"
      type="button"
      onClick={openCalendly}
      className="fixed bottom-5 right-5 z-50 rounded-full border border-white/15 bg-cyan-500 px-5 py-3 text-sm font-bold text-white shadow-2xl shadow-cyan-950/40 transition hover:-translate-y-0.5 hover:bg-cyan-400 focus:outline-none focus:ring-2 focus:ring-cyan-200 md:bottom-7 md:right-7"
      aria-label="Book a consultation"
      title={ready ? "Book a Consultation" : "Open scheduling"}
    >
      Book a Consultation
    </button>
  );
}

